import { render, staticRenderFns } from "./DefaultAdminTemplate.vue?vue&type=template&id=76657f2d&scoped=true"
import script from "./DefaultAdminTemplate.vue?vue&type=script&lang=js"
export * from "./DefaultAdminTemplate.vue?vue&type=script&lang=js"
import style0 from "./DefaultAdminTemplate.vue?vue&type=style&index=0&id=76657f2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76657f2d",
  null
  
)

export default component.exports